var _circle, _circle2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 31.5,
    stroke: "black",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 31.5,
    stroke: "url(#paint0_linear_172_4364)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9917 33L48.1648 21.827C48.695 21.2976 48.9933 20.5793 48.994 19.8301C48.9946 19.0808 48.6976 18.362 48.1683 17.8317C47.639 17.3014 46.9207 17.0032 46.1714 17.0025C45.4221 17.0018 44.7033 17.2988 44.173 17.8282L33 29.0012L21.827 17.8282C21.2967 17.2979 20.5775 17 19.8276 17C19.0776 17 18.3584 17.2979 17.8282 17.8282C17.2979 18.3584 17 19.0776 17 19.8276C17 20.5775 17.2979 21.2967 17.8282 21.827L29.0012 33L17.8282 44.173C17.2979 44.7033 17 45.4225 17 46.1724C17 46.9224 17.2979 47.6416 17.8282 48.1718C18.3584 48.7021 19.0776 49 19.8276 49C20.5775 49 21.2967 48.7021 21.827 48.1718L33 36.9988L44.173 48.1718C44.7033 48.7021 45.4225 49 46.1724 49C46.9224 49 47.6416 48.7021 48.1718 48.1718C48.7021 47.6416 49 46.9224 49 46.1724C49 45.4225 48.7021 44.7033 48.1718 44.173L36.9917 33Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9917 33L48.1648 21.827C48.695 21.2976 48.9933 20.5793 48.994 19.8301C48.9946 19.0808 48.6976 18.362 48.1683 17.8317C47.639 17.3014 46.9207 17.0032 46.1714 17.0025C45.4221 17.0018 44.7033 17.2988 44.173 17.8282L33 29.0012L21.827 17.8282C21.2967 17.2979 20.5775 17 19.8276 17C19.0776 17 18.3584 17.2979 17.8282 17.8282C17.2979 18.3584 17 19.0776 17 19.8276C17 20.5775 17.2979 21.2967 17.8282 21.827L29.0012 33L17.8282 44.173C17.2979 44.7033 17 45.4225 17 46.1724C17 46.9224 17.2979 47.6416 17.8282 48.1718C18.3584 48.7021 19.0776 49 19.8276 49C20.5775 49 21.2967 48.7021 21.827 48.1718L33 36.9988L44.173 48.1718C44.7033 48.7021 45.4225 49 46.1724 49C46.9224 49 47.6416 48.7021 48.1718 48.1718C48.7021 47.6416 49 46.9224 49 46.1724C49 45.4225 48.7021 44.7033 48.1718 44.173L36.9917 33Z",
    fill: "url(#paint1_linear_172_4364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_4364",
    x1: 3,
    y1: 33,
    x2: 63,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_172_4364",
    x1: 17,
    y1: 33,
    x2: 49,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossImage);
export default __webpack_public_path__ + "static/media/crossImage.2d8f73b02cb544e3dd08c74fb19f3f5e.svg";
export { ForwardRef as ReactComponent };